import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { getEntityType } from './helpers'

import './style.scss'

export default class IconCell extends Component {
    static propTypes = {
        typeCd: PropTypes.string.isRequired,
    }

    render() {
        const { typeCd } = this.props

        return <div className={cx(`group-table-icon-cell type-${getEntityType(typeCd)}`)} />
    }
}
